import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

import Type from './Type'
import EditType from '../components/EditType'

@connect(({ sites, roles }, { match }) => ({
  role: roles.find(t => t.slug === match.params.type) || roles[0]
}))
export default class extends Component {
  render () {
    const {match, role} = this.props

    return <Switch>
      <Route exact path='/:siteId/users/new' component={EditType} />
      <Route path='/:siteId/users/:type' component={Type} />
      <Redirect exact from={match.url} to={`${match.url}/${role.slug}`} />
    </Switch>
  }
}



// WEBPACK FOOTER //
// ./app/containers/Users.js